import Hammer from 'hammerjs';
import Point from './point';
import Path from './path';
import Erasure from './erasure';
export var MODE_TOUCH;
(function (MODE_TOUCH) {
    MODE_TOUCH[MODE_TOUCH["pan"] = 0] = "pan";
    MODE_TOUCH[MODE_TOUCH["move"] = 1] = "move";
})(MODE_TOUCH || (MODE_TOUCH = {}));
;
export default class {
    constructor(canvas, image, { size = 20, maxScale = 6, minScale = 1, padding = 20, color = '#000', onStackChange = (stack) => { } }) {
        this._stack = [];
        this._scaleValue = 1;
        this._offsetX = (ev) => {
            const offset = ev.target.getBoundingClientRect();
            return ev.center.x - offset.left;
        };
        this._offsetY = (ev) => {
            const offset = ev.target.getBoundingClientRect();
            return ev.center.y - offset.top;
        };
        this._canvas = canvas;
        this._context = canvas.getContext('2d');
        this._image = image;
        this._mode = MODE_TOUCH.pan;
        this._svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
        this._matrix = this._svg.createSVGMatrix();
        this._offset = new Point(this._canvas.width / 2, this._canvas.height / 2);
        const box = this._canvas.getBoundingClientRect();
        const scale = this._canvas.width / box.width;
        this._size = size * scale;
        this._maxScale = maxScale;
        this._minScale = minScale;
        this._padding = padding * scale;
        this._color = color;
        this._onStackChange = onStackChange;
        const _hammer = new Hammer(canvas);
        _hammer.get('pinch').set({ enable: true });
        _hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL });
        // 拖动开始
        _hammer.on('panstart', this._panstart.bind(this));
        // 拖动中
        _hammer.on('panmove', this._panmove.bind(this));
        // 拖动结束
        _hammer.on('panend', this._panend.bind(this));
        // 开始缩放
        _hammer.on('pinchstart', this._pinchstart.bind(this));
        // 缩放中
        _hammer.on('pinchmove', this._pinchmove.bind(this));
        // 绘制
        this._draw();
    }
    /** 变化模式 */
    modeToggle() {
        this._mode = this._mode === MODE_TOUCH.pan ? MODE_TOUCH.move : MODE_TOUCH.pan;
    }
    /** 销毁 */
    dispose() {
        this._clear();
        this._canvas.width = 0;
        this._canvas.height = 0;
    }
    /** 切换到橡皮擦模式 */
    togglePan() {
        this._mode = MODE_TOUCH.pan;
    }
    /** 切换到手势移动模式 */
    toggleMove() {
        this._mode = MODE_TOUCH.move;
    }
    /** 图片替换 */
    changeImage(image) {
        this._image = image;
        this._draw();
    }
    /** 生成 */
    async toErasureURL() {
        this._clear();
        if (this._context) {
            this._context.setTransform(1, 0, 0, 1, 0, 0);
            const _width = this._canvas.width - this._padding * 2;
            const _height = this._canvas.height - this._padding * 2;
            let _imageWidth = _width;
            let _imageHeight = this._image.height * _imageWidth / this._image.width;
            // 根据宽高比赋值渲染尺寸
            if (this._image.width / _width < this._image.height / _height) {
                _imageHeight = _height;
                _imageWidth = this._image.width * _imageHeight / this._image.height;
            }
            const dx = (this._canvas.width - _imageWidth) / 2;
            const dy = (this._canvas.height - _imageHeight) / 2;
            this._context.globalCompositeOperation = 'source-over';
            this._context.drawImage(this._image, dx, dy, _imageWidth, _imageHeight);
            // 擦除
            this._drawErasured();
            const source = this._canvas.toDataURL();
            this._clear();
            const image = await this._loadImage(source);
            this._canvas.width = _imageWidth;
            this._canvas.height = _imageHeight;
            this._context.drawImage(image, dx, dy, _imageWidth, _imageHeight, 0, 0, _imageWidth, _imageHeight);
        }
        this._stack = [];
        this._onStackChange(this._stack);
        return this._canvas.toDataURL();
    }
    /** 撤销 */
    revoke() {
        this._stack.pop();
        this._onStackChange(this._stack);
        this._draw();
    }
    /** 更新橡皮擦的尺寸 */
    setSize(value) {
        const box = this._canvas.getBoundingClientRect();
        const scale = this._canvas.width / box.width;
        this._size = value * scale;
    }
    /** 放大 */
    zoomIn(scale = 1.1) {
        this._offset.x = this._canvas.clientWidth / 2;
        this._offset.y = this._canvas.clientHeight / 2;
        this._zoom(scale);
    }
    /** 缩小 */
    zoomOut(scale = 0.9) {
        this._offset.x = this._canvas.clientWidth / 2;
        this._offset.y = this._canvas.clientHeight / 2;
        this._zoom(scale);
    }
    /** 清除 */
    _draw() {
        this._clear();
        this._drawImage();
        this._drawErasured();
        this._drawErasuring();
    }
    /** 绘制底图 */
    _drawImage() {
        const _width = this._canvas.width - this._padding * 2;
        const _height = this._canvas.height - this._padding * 2;
        let _imageWidth = _width;
        let _imageHeight = this._image.height * _imageWidth / this._image.width;
        // 根据宽高比赋值渲染尺寸
        if (this._image.width / _width < this._image.height / _height) {
            _imageHeight = _height;
            _imageWidth = this._image.width * _imageHeight / this._image.height;
        }
        if (this._context) {
            this._context.globalCompositeOperation = 'source-over';
            this._context.drawImage(this._image, (this._canvas.width - _imageWidth) / 2, (this._canvas.height - _imageHeight) / 2, _imageWidth, _imageHeight);
        }
    }
    /** 绘制正在擦除的路径 */
    _drawErasuring() {
        if (this._pathing && this._context) {
            this._context.globalCompositeOperation = 'source-over';
            this._context.strokeStyle = this._color;
            this._context.lineWidth = this._size;
            this._context.lineJoin = 'round';
            this._context.lineCap = 'round';
            this._pathing.drawPath(this._context);
            this._context.stroke();
        }
    }
    /** 绘制已经擦除的路径 */
    _drawErasured() {
        this._stack.forEach(item => {
            this._drawStroke(item.path, item.size);
        });
    }
    /** 绘制擦除路径 */
    _drawStroke(path, width) {
        if (this._context) {
            this._context.globalCompositeOperation = 'destination-out';
            this._context.strokeStyle = '#000';
            this._context.lineWidth = width;
            this._context.lineJoin = 'round';
            this._context.lineCap = 'round';
            path.drawPath(this._context);
            this._context.stroke();
        }
    }
    /** 重置 */
    reset() {
        this._clear();
        this._drawImage();
        this._stack = [];
        this._onStackChange(this._stack);
    }
    /** 清除canvas */
    _clear() {
        if (this._context) {
            this._context.save();
            this._context.setTransform(1, 0, 0, 1, 0, 0);
            this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
            this._context.restore();
        }
    }
    _panstart(ev) {
        if (this._mode == MODE_TOUCH.pan) {
            this._pathing = new Path();
        }
        else if (this._mode == MODE_TOUCH.move) {
            this._offset.x = this._offsetX(ev);
            this._offset.y = this._offsetY(ev);
            this._normalizedOffset = this._transformedPoint(this._offset);
        }
    }
    _panmove(ev) {
        this._offset.x = this._offsetX(ev);
        this._offset.y = this._offsetY(ev);
        const point = this._transformedPoint(this._offset);
        if (this._mode == MODE_TOUCH.pan) {
            this._pathing && this._pathing.addPoint(point);
            this._draw();
        }
        else if (this._mode == MODE_TOUCH.move && this._normalizedOffset) {
            this._translate(point.x - this._normalizedOffset.x, point.y - this._normalizedOffset.y);
            this._draw();
        }
    }
    _panend() {
        if (this._mode == MODE_TOUCH.pan) {
            if (this._pathing) {
                this._stack.push(new Erasure(this._pathing, this._size));
                this._onStackChange(this._stack);
            }
            this._pathing = undefined;
            this._draw();
        }
        this._normalizedOffset = undefined;
    }
    _pinchstart(ev) {
        this._offset.x = this._offsetX(ev);
        this._offset.y = this._offsetY(ev);
    }
    _pinchmove(ev) {
        let scale = 1 + (ev.scale - 1) / 12;
        if (ev.scale < 1) {
            scale = 1 + (ev.scale - 1) / 6;
        }
        this._zoom(scale);
        ev.preventDefault();
    }
    _zoom(scale) {
        if (this._scaleValue * scale <= this._maxScale && this._scaleValue * scale >= this._minScale) {
            this._scaleValue *= scale;
            const point = this._transformedPoint(this._offset);
            this._translate(point.x, point.y);
            this._scale(scale);
            this._translate(-point.x, -point.y);
            this._draw();
        }
    }
    _scale(scale) {
        this._matrix = this._matrix.scaleNonUniform(scale, scale);
        this._context && this._context.scale(scale, scale);
    }
    _translate(x, y) {
        this._matrix = this._matrix.translate(x, y);
        this._context && this._context.translate(x, y);
    }
    _transformedPoint(point) {
        let _point = this._svg.createSVGPoint();
        const box = this._canvas.getBoundingClientRect();
        const scale = this._canvas.width / box.width;
        _point.x = point.x * scale;
        _point.y = point.y * scale;
        _point = _point.matrixTransform(this._matrix.inverse());
        return new Point(_point.x, _point.y);
    }
    _loadImage(data) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = _ => resolve(image);
            image.onerror = _ => reject(image);
            image.src = data;
        });
    }
}
//# sourceMappingURL=index.js.map